
import { defineComponent } from "vue";
import { useSidebar } from "./utils";

export default defineComponent({
  name: "Sidebar",
  inheritAttrs: false,
  props: {
    side: {
      type: String,
      default: "left",
    },
    variant: {
      type: String,
      default: "sidebar",
    },
    collapsible: {
      type: String,
      default: "offcanvas",
    },
  },
  setup() {
    const { isMobile, state, openMobile, setOpenMobile } = useSidebar();

    return {
      isMobile,
      state,
      openMobile,
      setOpenMobile,
    };
  },
});
